import styled from '@xstyled/styled-components';

export const MsalComponentContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100vh;
    background-color: #f0f0f0; /* Light grey background for the whole screen */
    color: black;
`;

export const MessageBox = styled.div`
    background-color: white;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    text-align: center;
    color: black;
    font-size: 20px;
    margin: 20px;
`;
